import { fetch } from '../../api';
import { fetchData } from './dataActionsCreator';

export function fetchGroup(groupCode) {
  const fetchFunction = async function() {
    const { payload: { groups } } = await fetch(
      'communities',
      { query: { subDomain: groupCode } },
    );
    return { groups };
  };

  return fetchData(fetchFunction);
}

export function fetchUserGroup(userID) {
  const fetchFunction = async function() {
    const { payload: { groups } } = await fetch(
      'communities',
      { query: { userID } },
    );
    return { groups };
  };

  return fetchData(fetchFunction);
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/groupActionsCreator.js